import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { AppService } from '../services/app.service';

@Component({
  selector: 'app-model-actions',
  templateUrl: './model-actions.component.html',
  standalone: true,
  imports: [NgIf, MatIconModule, AsyncPipe],
  styleUrls: ['./model-actions.component.scss']
})
export class ModelActionsComponent {
  @Input() id?: string;
  @Input() modelType!: string;
  @Input() action?: string;

  constructor(public appService: AppService) {}

  @Output() add = new EventEmitter<void>();
  @Output() update = new EventEmitter<void>();
  @Output() remove = new EventEmitter<void>();
}
